export const TITLE = 'Contact details';
export const SUB_TITLE = 'Please select the contact details of the person who\'ll be on site when the engineer visits. Or add a new site contact.';
export const ANALYTICS_APPT_ADD_SITE_CONTACT = 'amend appt:Add new site contact';
export const CONTACT_DETAILS_GROUP_LEGEND_TEXT = 'All site contacts';
